import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaUsers } from "react-icons/fa";
import { GrDocumentUser } from "react-icons/gr";
import './layout.css';

const LeaveReportLayout = ({ children }) => {
  const location = useLocation();
  
  return (
    <div style={{marginTop:'10px'}}>
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="all-leave-report-link"
                className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/leave-report') ? 'active' : ''}`}
                to="/leave-report"
              >
                <GrDocumentUser className="nav-icon" /> Overall Leave Report
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="emps-leave-reports-link"
                className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/emps-leave-reports') ? 'active' : ''}`}
                to="/emps-leave-reports"
              >
                <FaUsers className="nav-icon" /> Employee Leave Report
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default LeaveReportLayout;
